// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <span ng-bind=\"row.entity.startToEndDate\"></span>\n    </div>\n</div>";
// Exports
module.exports = code;